const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The account or contact in the ⌘J context, so the assistant can ground on its strategic brief. */
export function contextRecordIds(kind: string | undefined, id: string | undefined): { accountId?: string; contactId?: string } | undefined {
  if (!id || !UUID.test(id)) return undefined;
  if (kind === 'account') return { accountId: id };
  if (kind === 'contact') return { contactId: id };
  return undefined;
}
